export default {
  site_name: '韩漫屋',
  site_slogan: '无遮韩国免费漫画大全',
  home: '首页',
  category: '分类',
  about: '关于我们',
  read_now: '开始阅读',
  popular: '热门推荐',
  latest: '最近更新',
  free: '完全免费',
  no_registration: '无需注册',
  complete: '完整无删减',
  daily_update: '每日更新',
  all_categories: '全部分类',
  comic_detail: '漫画详情',
  chapter_list: '章节列表',
  read_chapter: '开始阅读',
  bookmark: '收藏',
  author: '作者',
  rating: '评分',
  views: '阅读次数',
  status: '状态',
  ongoing: '连载中',
  completed: '已完结',
  related: '同类推荐',
  about_us: '关于我们',
  brand_story: '品牌故事',
  testimonials: '读者口碑',
  faq: '常见问题',
  contact: '联系我们',
  our_promise: '我们的承诺',
};